export default "__VITE_ASSET__CV7y8Tuz__"